/**
 * ViewModeToggle - Toggle between Pressure and Opportunity map views
 *
 * Provides a simple radio button toggle at the top of the map that allows
 * users to switch between viewing regulatory pressure scores and market
 * opportunity scores.
 */

import { ViewMode, viewModeConfigs } from '@/data/regulatoryData';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

export function ViewModeToggle({ viewMode, onViewModeChange }: ViewModeToggleProps) {
  return (
    <div className="glass rounded-lg shadow-glass p-2">
        <div className="flex items-center gap-1 text-[10px] text-text-tertiary mb-1.5 px-1">
          <span className="uppercase tracking-wider font-medium">View Mode</span>
          <kbd className="ml-auto px-1.5 py-0.5 rounded bg-white/10 text-text-tertiary">V</kbd>
        </div>
        <div className="flex gap-1.5">
          {(Object.keys(viewModeConfigs) as ViewMode[]).map((mode) => {
            const config = viewModeConfigs[mode];
            const isActive = viewMode === mode;

            return (
              <button
                key={mode}
                onClick={() => onViewModeChange(mode)}
                className={`
                  flex items-center gap-2 px-3 py-1.5 rounded-md transition-all text-xs
                  ${isActive
                    ? 'bg-white/15 text-text-primary'
                    : 'text-text-secondary hover:bg-white/5 hover:text-text-primary'
                  }
                `}
                title={config.description}
              >
                <div
                  className={`w-1.5 h-1.5 rounded-full transition-colors ${isActive ? 'bg-brand' : 'bg-gray-600'}`}
                />
                <span className="font-medium">{config.label}</span>
              </button>
            );
          })}
        </div>
      </div>
  );
}

export default ViewModeToggle;
